import React, { Component } from 'react';

class About extends Component {
    constructor(props){
        super(props);
        this.state = {
            about: [
                { id: 1, icon: 'bi bi-graph-up', title: 'Fundamentos de identificación',
                  text: 'Aprende los principios teóricos y prácticos para modelar sistemas dinámicos a partir de datos.' },
                { id: 2, icon: 'bi bi-cpu', title: 'Técnicas clásicas y modernas',
                  text: 'Desde métodos paramétricos y no paramétricos hasta enfoques basados en machine learning.' },
                { id: 3, icon: 'bi bi-award', title: 'Certificación incluida',
                  text: 'Obtén un certificado oficial al finalizar el curso, válido para enriquecer tu perfil académico y profesional.' }
            ],
        }
    }

    scrollToContact = (e) => {
        e.preventDefault();
        const contactSection = document.getElementById('contact');
        if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
        }
    }

    render() {
        return (
            <section className="about-section section-padding dark-bg-light" id="about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="about-img">
                                <img src="assets/images/banner/ID_Course.png" alt="Curso de Identificación de Sistemas" className="img-fluid"/>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className="section-heading">
                                <span className="subheading">¡Inscripciones abiertas!</span>
                                <h1 className="heading-title">CURSO EN IDENTIFICACIÓN DE SISTEMAS</h1>
                                <p>Un programa intensivo diseñado para estudiantes y profesionales que quieran dominar las técnicas de modelado de sistemas lineales y no lineales a partir de datos experimentales Python, MATLAB o C++.</p>
                            </div>

                            {this.state.about.map((data,i) => (
                                <div className="about-text-block" key={i}>
                                    <i className={data.icon}></i>
                                    <h4>{data.title}</h4>
                                    <p>{data.text}</p>
                                </div>
                            ))}

                            {/* Botón que hace scroll hasta la sección Contact existente */}

                            <a
                              href="#contact"
                              className="btn btn-main"
                              onClick={async (e) => {
                                e.preventDefault(); // Evita el comportamiento inmediato del enlace
                            
                                // 1️⃣ Llamada al microservicio backend
                                try {
                                  const backendUrl =
                                    window.location.hostname === "neuralnetadaptivecontrol.com"
                                      ? "https://controlbook.onrender.com"
                                      : "http://localhost:3000";
                            
                                  await fetch(`${backendUrl}/clicks`, {
                                    method: "POST",
                                    headers: { "Content-Type": "application/json" },
                                    body: JSON.stringify({
                                      sessionId: "session-" + Math.random().toString(36).substr(2, 9),
                                      elementId: "curso-identificacion",
                                      pageUrl: window.location.href,
                                      elementType: "button",
                                      userId: "user-react",
                                      coordinates: { x: e.clientX, y: e.clientY },
                                      metadata: {
                                        product: "curso-neural-networks",
                                        price: 229.99,
                                        action: "signup-click",
                                      },
                                    }),
                                  });
                                } catch (err) {
                                  console.error("Error recording click:", err);
                                }
                            
                                // 2️⃣ Scroll a la sección contact
                                const contactSection = document.getElementById("contact");
                                if (contactSection) {
                                  contactSection.scrollIntoView({ behavior: "smooth" });
                                }
                              }}
                            >
                              Inscribirme ahora 229.99 €
                            </a>

                            <p> </p>  
                            <p>
                              ¿Quieres más información?{" "}
                              <a
                                href="#"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={async (e) => {
                                  e.preventDefault(); // Evita la navegación
                            
                                  // Registrar click en backend
                                  try {
                                    const backendUrl =
                                      window.location.hostname === "neuralnetadaptivecontrol.com"
                                        ? "https://controlbook.onrender.com"
                                        : "http://localhost:3000";
                            
                                    await fetch(`${backendUrl}/clicks`, {
                                      method: "POST",
                                      headers: { "Content-Type": "application/json" },
                                      body: JSON.stringify({
                                        sessionId: "session-" + Math.random().toString(36).substr(2, 9),
                                        elementId: "download-programa-is",
                                        pageUrl: window.location.href,
                                        elementType: "link",
                                        userId: "user-react",
                                        coordinates: { x: e.clientX, y: e.clientY },
                                        metadata: {
                                          action: "download",
                                          file: "programa.pdf",
                                        },
                                      }),
                                    });
                                  } catch (err) {
                                    console.error("Error recording click:", err);
                                  }
                            
                                  // Por ahora no abrir nada
                                }}
                              >
                                Descarga el programa
                              </a>
                            </p>
         
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default About;
